import * as React from 'react';
import AvatarWrapper from '../AvatarWrapper/AvatarWrapper';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import UserModel from '../../types/UserModel';

export default ({user, reviewer}: NonOwnerReviewerProps) => {
   return (
       <div className="row">
          <div className="reviewer-avatar-glyph">
             <AvatarWrapper key={reviewer.Id} user={user}/>
          </div>
          <div className="reviewer-name" title={user.name}>
             {user.name}
          </div>
       </div>
   );
};

export interface NonOwnerReviewerProps {
   user: UserModel;
   reviewer: SimpleReviewerModel;
}